import { render, staticRenderFns } from "./BaseExpandControl.vue?vue&type=template&id=bfe20d7a&"
import script from "./BaseExpandControl.vue?vue&type=script&lang=js&"
export * from "./BaseExpandControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports